<div class="root-container">
  &copy; {{ year }} Hytec Power Inc.
</div>
